import Image from '@/components/Image/RemoteImage';
import Container from '@/components/Container';
import SubHeading from '@/components/SubHeading';
import SectionContactLinks from '@/domain/Contact/SectionContactLinks';

export default function Contact() {
  return (
    <div className="bg-white bg-gradient-to-t from-gray-100 to-white">
      <div className="relative overflow-hidden">
        <div className="absolute right-0 top-0 z-0 mt-10 -mr-10 h-52 w-1/5 -skew-y-6 transform bg-gradient-to-l from-green-300 to-transparent opacity-50" />
        <div className="absolute right-0 top-0 z-0 mt-36 h-52 w-1/5 -skew-y-6 transform bg-gradient-to-l from-green-300 to-transparent opacity-50" />
        <Container className="py-10 lg:py-20">
          <div className="grid grid-cols-1 space-y-8 lg:grid-cols-12 lg:gap-10 lg:space-y-0 xl:gap-16">
            <div className="relative z-20 lg:col-span-6 lg:flex lg:flex-col lg:justify-center">
              <SubHeading heading="Contáctenos" />
              <div className="space-y-4 lg:space-y-8">
                <h1 className="text-4xl font-extrabold tracking-tight lg:text-6xl">
                  Impulsamos empresas de todos los tamaños
                </h1>
                <p className="text-lg text-gray-600 lg:pr-20">
                  Póngase en contacto ahora para analizar cómo podemos ayudarlo
                  a entregar más y mejores resultados en la adopción de una
                  cultura ágil.
                </p>
              </div>
            </div>
            <div className="relative z-20 space-y-4 lg:col-span-6 lg:flex lg:flex-col lg:items-center">
              <div className="flex transform overflow-hidden rounded-lg bg-gray-100 shadow-2xl lg:rounded-xl xl:rounded-2xl">
                <Image
                  src="v1610716308/contacto/imagen-principal_pewumy.webp"
                  width={600}
                  height={600}
                  alt="Contáctenos"
                  className="h-auto max-w-full rounded-lg lg:rounded-xl xl:rounded-2xl"
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <SectionContactLinks />
    </div>
  );
}
